import { InjectionToken } from "@angular/core";
import { AppResolver } from "./app.resolver";
import { Resolve } from "@angular/router";
import { IApp } from "../../../../models/application/i-app";

export const appResolverInjectionToken: InjectionToken<Resolve<IApp>> = new InjectionToken<Resolve<IApp>>("digital-signage-developer-dashboard.AppResolver");
